module.exports = __webpack_public_path__ + "img/spinner.3f7904ad.gif";